<template>
  <div>
    <div class="carousel">
      <van-swipe @change="onChange" :show-indicators="false">
        <van-swipe-item
          v-for="(image, index) in clubDetail.clubImgs"
          :key="index"
        >
          <!--          <img v-lazy="baseImg + image"  class="imgPic"/>-->
          <img
            :src="baseImg + image"
            alt=""
            class="imgPic"
            @load="activityLoad(image, index)"
            v-show="image && loadingImges[index]"
          />
          <img
            src="@/assets/img/iv_placeholder_carousel@2x.png"
            v-show="!image || !loadingImges[index]"
            class="imgPic"
          />
        </van-swipe-item>
      </van-swipe>
      <div class="subscript">
        <span class="currentIndex">{{ currentIndex + 1 }}</span
        >/<span class="allSum">{{ clubDetail.clubImgs.length }}</span>
      </div>
    </div>

    <div class="padBox">
      <div class="proName">{{ clubDetail.clubName }}</div>
      <div class="star van-clearfix">
        <!--        <img src="@/assets/img/position_icon_location.png" alt="" class="starLi">-->
        <!--        <img src="@/assets/img/position_icon_location.png" alt="" class="starLi">-->
        <!--        <img src="@/assets/img/position_icon_location.png" alt="" class="starLi">-->
        <!--        <img src="@/assets/img/position_icon_location.png" alt="" class="starLi">-->
        <!--        <img src="@/assets/img/position_icon_location.png" alt="" class="starLi">-->
        <!--        <div>-->
        <!--          <span class="score">{{clubDetail.score}}</span><span class="minute">分</span>-->
        <!--        </div>-->
        <my-star :rating="clubDetail.score" />
      </div>
      <div class="serviceList">
        <ul
          class="van-clearfix"
          v-if="
            clubDetail.clubProductCategorys &&
            clubDetail.clubProductCategorys.length > 0
          "
        >
          <li
            class="inBlock"
            v-for="(itemWrap, indexWrap) in clubDetail.clubProductCategorys"
            :key="indexWrap"
          >
            <div class="serviceLi">
              {{ itemWrap.categoryName }}
            </div>
          </li>
        </ul>
      </div>
      <div class="businessTime">{{ clubDetail.openDate }}</div>
      <!--      <div class="">-->
      <!--        <ul class=""  v-if="clubDetail.otherService.length > 0">-->
      <!--          <li class="inBlock" v-for="(itemWrap,indexWrap) in clubDetail.otherService" :key="indexWrap">-->
      <!--            <div class="otherServiceLi" v-if="indexWrap < 3">-->
      <!--              {{itemWrap}}-->
      <!--            </div>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->
      <div class="serviceList">
        <div v-if="clubDetail.serviceList">
          <ul class="van-clearfix" v-if="clubDetail.serviceList.length > 0">
            <li
              class="inBlock"
              v-for="(itemWrap, indexWrap) in clubDetail.serviceList"
              :key="indexWrap"
            >
              <div class="otherServiceLi">
                {{ itemWrap }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="flexCenter padBox">
      <div
        class="flexOne address"
        @click="
          goMap(
            clubDetail.longitude,
            clubDetail.latitude,
            clubDetail.clubName,
            clubDetail.address
          )
        "
      >
        <div class="a_address">{{ clubDetail.address }}</div>
        <!--        <div class="b_address">距地铁2号线水湾站C口步行1.0km</div>-->
      </div>
      <!--      <img src="@/assets/img/healthcenter_icon_telephone@2x.png" alt="" class="i_logo">-->
      <a v-if="isPhone" :href="'tel:' + clubDetail.phone" class="i_logo">
        <img
          src="@/assets/img/healthcenter_icon_telephone@2x.png"
          alt=""
          class=""
        />
      </a>
      <a v-if="!isPhone" class="i_logo" @click="toPhone(clubDetail.phone)">
        <img
          src="@/assets/img/healthcenter_icon_telephone@2x.png"
          alt=""
          class=""
        />
      </a>
    </div>
    <div class="line"></div>
    <!--项目列表-->
    <div class="projectPage">
      <div class="topDiv sticky">
        <div
          class="div"
          v-for="(item, index) in projectTypeList"
          :key="index"
          @click="projectTypeClick(item.categoryId)"
        >
          <img
            :src="baseImg + item.categoryUrl"
            alt=""
            class="projectTypeImg"
          />
          <span
            class="projectTypeName"
            :class="projectType == item.categoryId ? 'active' : ''"
            >{{ item.categoryName }}</span
          >
        </div>
      </div>
      <div class="bottomDiv">
        <div v-if="projectList">
          <ul class="van-clearfix" v-if="projectList.length > 0">
            <li
              class="li"
              v-for="(item, index) in projectList"
              :key="index"
              @click="projectClick(item)"
            >
              <img :src="baseImg + item.imgUrl" alt="" class="projectImg" />
              <img src="@/assets/img/iv_placeholder@2x.png" v-show="!item.imgUrl" alt="" class="projectImg" />
              <div class="project">
                <div class="projectTop">
                  <div class="name">{{ item.name }}</div
                  ><div class="price"
                    >{{ item.price }}元/{{ item.serviceDuration }}分钟</div
                  >
                </div>
                <div class="detailText">{{ item.detailText }}</div>
                <div class="viewText">查看详情></div>
              </div>
            </li>
          </ul>
        </div>
        <div v-else style="padding-top: 1rem; text-align: center">
          <img src="@/assets/img/iv_error1@2x.png" class="noAct" />
          <div class="actText">暂无项目</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TMap from "components/Tmap/Tmap";
import MyStar from "components/MyStar/MyStar";
import EnvionmentVariables from "../../../../baseUrl";
import Is from "is_js";
import { getToken } from "utils/auth";
import { browserEnvironment, linkApp, isWeixin, isApplet } from "utils/index";
const wx = require("weixin-js-sdk"); // 导入模块
export default {
  name: "todayActivity",
  components: {
    TMap,
    MyStar
  },
  data () {
    return {
      projectType: undefined,
      baseImg: EnvionmentVariables.IMAGE_HOST,
      clubImgs: [
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1603173779363&di=96af878d1f5a5146cb59147b05c76118&imgtype=0&src=http%3A%2F%2Fpic2bj.shejibao.com%2Fimg%2F2016%2F07%2F04%2Fe04783777872acbcab15e1fabd5b8153.jpg%40%2521width_1000",
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1603173779363&di=dcda9296e5d3bcdee4a9cacc912c6b27&imgtype=0&src=http%3A%2F%2Fimg005.hc360.cn%2Fm7%2FM05%2FDA%2F60%2FwKhQpFcFzDWERQ_vAAAAAKNltAk139.jpg"
      ],
      show: false,
      isPhone: false,
      goods: {
        // 默认商品 sku 缩略图
        picture: "https://img.yzcdn.cn/1.jpg"
      },
      currentIndex: 0,
      integerPrice: "",
      decimalsPrice: "",
      price: 192.9,
      modelList: [
        "智能加压入门级爆款U10L",
        "高清大屏热销款U12",
        "智能加压入门级爆款U10L",
        "高清大屏热销款U12",
        "【新款礼盒装】智能蓝牙U32",
        "高清大屏热销款U12"
      ],
      activeIndex: "",
      num: 1,
      clubDetail: {
        clubImgs: [],
        clubName: "南山淘沙国际水会",
        serviceList: [
          // "足底按摩",
          // "鱼疗",
          // "针灸",
          // "鱼疗",
          // "鱼疗",
          // "足底按摩",
          // "鱼疗",
          // "针灸",
          // "鱼疗",
          // "鱼疗",
          // "足底按摩",
          // "鱼疗",
          // "针灸",
          // "鱼疗",
          // "鱼疗",
        ],
        otherService: [
          // "免费停车", "有wifi"
        ],
        imgUrl:
          "https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=1259783416,3856319235&fm=26&gp=0.jpg",
        score: 5,
        businessTime: "10:00-23:00",
        clubProductCategorys: [],
        projectTypeList: []
      },
      loadingImges: {},
      projectTypeList: [
        // { img: "https://img.yzcdn.cn/1.jpg", name: "经络调理" },
        // { img: "https://img.yzcdn.cn/1.jpg", name: "女性专区" },
        // { img: "https://img.yzcdn.cn/1.jpg", name: "身体疼痛" },
        // { img: "https://img.yzcdn.cn/1.jpg", name: "身体疼痛" },
      ],
      projectList: [
        // {
        //   img: "https://img.yzcdn.cn/1.jpg",
        //   name: "肠胃调理",
        //   price: "180元/60分钟",
        //   detailText:
        //     "本项目适宜经络淤堵导致的神疲乏力、睡眠不佳、饮食不佳等症状需要唤醒活力的人士。",
        //   viewText: "查看详情>",
        //   id: 1,
        // },
        // {
        //   img: "https://img.yzcdn.cn/1.jpg",
        //   name: "肠胃调理",
        //   price: "180元/60分钟",
        //   detailText:
        //     "本项目适宜经络淤堵导致的神疲乏力、睡眠不佳、饮食不佳等症状需要唤醒活力的人士。",
        //   viewText: "查看详情>",
        // },
        // {
        //   img: "https://img.yzcdn.cn/1.jpg",
        //   name: "肠胃调理",
        //   price: "180元/60分钟",
        //   detailText:
        //     "本项目适宜经络淤堵导致的神疲乏力、睡眠不佳、饮食不佳等症状需要唤醒活力的人士。",
        //   viewText: "查看详情>",
        // },
        // {
        //   img: "https://img.yzcdn.cn/1.jpg",
        //   name: "肠胃调理",
        //   price: "180元/60分钟",
        //   detailText:
        //     "本项目适宜经络淤堵导致的神疲乏力、睡眠不佳、饮食不佳等症状需要唤醒活力的人士。",
        //   viewText: "查看详情>",
        // },
        // {
        //   img: "https://img.yzcdn.cn/1.jpg",
        //   name: "肠胃调理",
        //   price: "180元/60分钟",
        //   detailText:
        //     "本项目适宜经络淤堵导致的神疲乏力、睡眠不佳、饮食不佳等症状需要唤醒活力的人士。",
        //   viewText: "查看详情>",
        // },
      ]
    };
  },
  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff;");
  },
  created () {
    this.id = this.$route.query.id;
    document.title = this.$route.query.title;
  },
  mounted () {
    if (isWeixin()) {
      this.isPhone = true;
      // 通过config接口注入权限验证配置
      this.getConfig();
    } else {
      this.isPhone = false;
    }
    this.getClubDetails();
  },
  methods: {
    projectTypeClick (categoryId) {
      var that = this;
      that.projectType = categoryId;
      that.projectList = [];
      if (that.projectTypeList && that.projectTypeList.length > 0) {
        that.clubDetail.clubProducts.forEach((x) => {
          if (categoryId == x.categoryId) {
            that.projectList.push(x);
          }
        });
      }
    },
    // 点击跳转项目详情
    projectClick (item) {
      this.$router.push({ path: "/projectDetails", query: { id: item.id } }); // 1. 从会所详情进来
    },
    activityLoad (imgId, imgIndex) {
      if (imgId) {
        this.loadingImges[imgIndex] = true;
        this.$forceUpdate();
      }
    },
    // 获取商品详情
    getClubDetails () {
      var that = this;
      var param = {
        service: "appagg",
        query: this.id
      };
      this.$api.getClubDetailByClubId(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.clubDetail = res.data.result;
            if (!that.clubDetail.clubImgs) {
              that.clubDetail.clubImgs = [];
            }
            that.clubDetail.serviceList =
              that.clubDetail.serviceFeatures.split(",");
            that.projectTypeList = that.clubDetail.clubProductCategorys;
            that.projectList = [];
            if (that.projectTypeList && that.projectTypeList.length > 0) {
              that.projectType = that.projectTypeList[0].categoryId;
              that.clubDetail.clubProducts.forEach((x) => {
                if (that.projectTypeList[0].categoryId == x.categoryId) {
                  that.projectList.push(x);
                }
              });
            }
            localStorage.setItem("clubDetail", JSON.stringify(that.clubDetail));
          }
        }
      });
    },
    choose (index) {
      this.activeIndex = index;
    },
    onChange (index) {
      this.currentIndex = index;
    },
    toPhone (phone) {
      console.log(phone, "phone");
      let options = {
        iphoneHasToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone
          };
          linkApp(appParams, "", appParams.pageType);
        },
        iphoneNoToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidHasToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidNoToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserHasToken: () => {},
        browserNoToken: () => {}
      };
      browserEnvironment(options);
    },
    //  通过config接口注入权限验证配置
    getConfig () {
      let _this = this;
      // var url = localStorage.getItem("url");
      let url = window.location.href.split("#")[0];
      if (window.wechaturl !== undefined) {
        url = window.wechaturl;
      }
      var param = {
        service: "appagg",
        // query: encodeURIComponent((window.location.href).split('#')[0])
        // query: (window.location.href).split('#')[0]
        query: url
      };
      console.log("url");
      console.log(url);
      // console.log("href")
      // console.log((window.location.href))
      // console.log("没有编码 url")
      // console.log((window.location.href).split('#')[0])
      // console.log("编码后 url")
      // console.log(encodeURIComponent((window.location.href).split('#')[0]))
      this.$api
        .getWechatSign(param)
        .then((res) => {
          if (res) {
            if (res.data.basis.status === 200) {
              console.log("result");
              console.log(res.data.result);
              let data = res.data.result;
              wx.config({
                debug: false,
                appId: data.appid,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: ["openLocation"],
                success: function (res) {
                  console.log("wx.config success");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
                fail: function (res) {
                  console.log("wx.config fail");
                  console.log(res);
                  // alert(JSON.stringify(res));
                }
              });
              wx.checkJsApi({
                // 判断当前客户端版本是否支持指定JS接口
                jsApiList: ["openLocation"],
                success: function (res) {
                  console.log("success");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
                fail: function (res) {
                  console.log("fail");
                  console.log(res);
                  // alert(JSON.stringify(res));
                }
              });
              wx.ready(function () {
                // wx.openLocation({
                //     latitude: 22.545538, // 纬度，浮点数，范围为90 ~ -90
                //     longitude: 114.054565, // 经度，浮点数，范围为180 ~ -180。
                //     name: '象山影视城', // 位置名
                //     address: '位置名的详情说明', // 地址详情说明
                //     scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
                // })
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              });
              wx.error((err) => {
                console.log("err");
                console.log(err);
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 将百度地图经纬度转换为腾讯/高德地图经纬度
    bMapTransQQMap (lng, lat) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats
      };
    },
    goMap (longitude, latitude, agencyName, address) {
      let options = {
        token: getToken(),
        appletHasToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18 // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        appletNoToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18 // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        weiXinHasToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18 // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        weiXinNoToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18 // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        iphoneHasToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address:address,
          //     agencyName: agencyName,
          //     // token: this.token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        },
        iphoneNoToken: () => {
          // 在h5用腾讯地图javaScript打开
          //  this.$router.push({
          //     path: "/TCmap",
          //     query: {
          //       // province: this.province,
          //       // provinceName: this.provinceName,
          //       // cityName: this.cityName,
          //       // defaultCode: this.defaultCode,
          //       longitude: longitude,
          //       latitude: latitude,
          //       address:address,
          //       agencyName: agencyName,
          //       // token: this.token
          //     },
          //   });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidHasToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address:address,
          //     agencyName: agencyName,
          //     // token: this.token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidNoToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address:address,
          //     agencyName: agencyName,
          //     // token: this.token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserHasToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address:address,
          //     agencyName: agencyName,
          //     // token: this.token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserNoToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address:address,
          //     agencyName: agencyName,
          //     // token: this.token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: {
              agencyName: agencyName,
              longitude: longitude,
              latitude: latitude
            }
          };
          linkApp(appParams, "", appParams.pageType);
        }
      };
      browserEnvironment(options);
    },
    // goMap () {
    //   this.$router.push({ path: '/map', query: {latitude: this.clubDetail.latitude, longitude: this.clubDetail.longitude}});
    // },

    // goMap () {
    //   let that = this
    //   let options = {
    //     token: this.token,
    //     appletHasToken: () => {
    //       let xcxUrl = `/pages/bMap/bMap?latitude=${this.clubDetail.latitude}&longitude=${this.clubDetail.longitude}`
    //       wx.miniProgram.navigateTo({ url: xcxUrl })
    //     },
    //     appletNoToken: () => {
    //       let xcxUrl = `/pages/bMap/bMap?latitude=${this.clubDetail.latitude}&longitude=${this.clubDetail.longitude}`
    //       wx.miniProgram.navigateTo({ url: xcxUrl })
    //     },
    //     weiXinHasToken: () => {
    //     },
    //     weiXinNoToken: () => {
    //     },
    //     iphoneHasToken: () => {
    //       let appParams = {
    //         pageType: 'gohome'
    //       }
    //       linkApp(appParams, '', appParams.pageType)
    //     },
    //     iphoneNoToken: () => {
    //       let appParams = {
    //         pageType: 'gohome'
    //       }
    //       linkApp(appParams, '', appParams.pageType)
    //     },
    //     androidHasToken: () => {
    //       let appParams = {
    //         pageType: 'gohome'
    //       }
    //       linkApp(appParams, '', appParams.pageType)
    //     },
    //     androidNoToken: () => {
    //       let appParams = {
    //         pageType: 'gohome'
    //       }
    //       linkApp(appParams, '', appParams.pageType)
    //     },
    //     browserHasToken: () => {
    //     },
    //     browserNoToken: () => {
    //     }
    //   };
    //   browserEnvironment(options)
    // },
    linkBuyCart () {
      this.$router.replace({ path: "/shopCart", query: {} });
    },
    goBack () {
      this.$router.replace({ path: "/search", query: {} });
    },
    sureGo () {
      this.$router.replace({ path: "/confirmOrder", query: {} });
    },
    // 下拉刷新
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.infoList = [];
        this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getInfoMationList(this.pid); // 加载数据
        this.timer = null; // 清空定时器
      }, 300);
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getInfoMationList(this.pid);
    }
  }
};
</script>

<style scoped lang="less">
/*.minute{*/
/*  color: #FFAF46;*/
/*  font-size: 12px;*/
/*  vertical-align: top;*/
/*}*/
.tmap {
  width: 100%;
  height: 600px;
}
.address {
  border-right: 2px solid rgba(208, 214, 230, 0.31);
}
.b_address {
  color: #3e3e3e;
  font-size: 24px;
  margin-top: 10px;
}
.a_address {
  color: #3e3e3e;
  font-size: 29px;
}
.i_logo {
  width: 96px;
  height: 96px;
  margin-left: 20px;
}
.i_logo img {
  width: 100%;
  height: 100%;
}
.line {
  height: 8px;
  background: rgba(208, 214, 230, 0.31);
  width: 100%;
}
.businessTime {
  color: #3e3e3e;
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: -10px;
}
.inBlock {
  display: inline-block;
  margin-bottom: 3px;
}
.otherServiceLi {
  padding: 8px;
  background: rgba(53, 125, 250, 0.1);
  border-radius: 4px;
  color: #357dfa;
  font-size: 20px;
  /*display: inline-block;*/
  margin-right: 18px;
}
.inBlock:last-child .serviceLi {
  border: none;
}
.inBlock:first-child .serviceLi {
  padding-left: 0px;
}
.serviceLi {
  height: 28px;
  padding: 0 18px;
  border-right: 2px solid rgba(208, 214, 230, 0.3);
  display: inline-block;
}
.serviceList {
  color: #3e3e3e;
  font-size: 20px;
  /*margin-bottom: 20px;*/
  margin-top: 27px;
  min-height: 30px;
  /*overflow: hidden;*/
  line-height: 1.3;
}
/*.score{*/
/*  margin-left: 16px;*/
/*  color: #FFAF46;*/
/*  font-size: 30px;*/
/*  float: left;*/
/*}*/
.starLi {
  width: 21px;
  height: 19px;
  float: left;
  margin-right: 6px;
}
.num {
  padding: 6px;
  font-size: 12px;
  color: #fff;
  background: red;
  border-radius: 50%;
  position: absolute;
  right: -4px;
  top: -4px;
}
.sure {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #ff3e29;
  border-radius: 12px;
  font-size: 32px;
  color: #fff;
  margin-top: 40px;
}
.plus {
  color: #3e3e3e;
  font-size: 60px;
}
.popTitle /deep/ .van-field__control {
  text-align: center;
}
.popTitle /deep/ .van-field {
  background: rgba(177, 177, 178, 0.2);
  border-radius: 8px;
  text-align: center;
  font-weight: bold;
  width: 100px;
  margin: 0 10px;
  padding: 0;
}
.mode.active {
  background: rgba(255, 62, 41, 0.1);
  border: 2px solid #ff3e29;
  border-radius: 12px;
}
.mode {
  background: rgba(177, 177, 178, 0.2);
  padding: 16px;
  border-radius: 12px;
  float: left;
  margin-right: 32px;
  margin-bottom: 20px;
  color: #3e3e3e;
  font-size: 24px;
  border: 2px solid transparent;
}
.popTitle {
  color: #3e3e3e;
  font-size: 28px;
  padding: 40px 0;
  font-weight: bold;
}
.wrap {
  align-self: flex-end;
}
.detail {
  color: #b1b1b2;
  font-size: 20px;
  margin-top: 30px;
}
.specil {
  height: 212px;
}
.proPic {
  width: 212px;
  height: 212px;
  margin-right: 24px;
  display: block;
}
/deep/ .van-popup--bottom {
  border-radius: 12px 12px 0px 0px;
  min-height: 300px;
  padding: 32px 32px 40px;
  box-sizing: border-box;
}
.shopLogo {
  width: 100px;
  height: 40px;
  margin-right: 12px;
  vertical-align: middle;
}
.shopName {
  width: 100%;
  height: 90px;
  line-height: 90px;
  padding: 0 29px;
  box-sizing: border-box;
  color: #3e3e3e;
  font-size: 24px;
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
}
.occupie {
  width: 100%;
  height: 32px;
  background: #f8f8f8;
}
.decimals {
  color: #ff3e29;
  font-size: 29px;
  font-weight: bold;
}
.value {
  color: #ff3e29;
  font-size: 60px;
}
.unit {
  color: #ff3e29;
  font-size: 29px;
}
.subscript {
  padding: 6px 17px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 24px;
  position: absolute;
  right: 64px;
  bottom: 38px;
  color: #fff;
  font-size: 24px;
  z-index: 100;
}
.carousel {
  height: 532px;
  position: relative;
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
}
.van-swipe {
  height: 532px;
}
.mask_layer {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  background: #000;
  opacity: 0.5;
  overflow: hidden;
  top: 0;
  left: 0;
}
.orgPrice {
  text-decoration: line-through;
  color: #999;
}
.proPrice {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  color: #3e3e3e;
  margin-bottom: 24px;
  align-items: baseline; // 元素位于容器的基线上
}
.allFlexCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padBox {
  padding: 20px 32px 32px;
}
.proName {
  font-size: 30px;
  /*margin-bottom: 27px;*/
  color: #3e3e3e;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 2px;
}
.imgPic {
  width: 100%;
  // height: 532px;
}

.f-box {
  position: fixed;
  width: 100%;
  height: 128px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  z-index: 9;
  cursor: pointer;
}
.shop-btn {
  flex: 1;
  text-align: center;
  padding-top: 15px;
}
.shop-btn .shop-icon {
  position: relative;
  width: 48px;
  height: 48px;
  margin: 0 auto;
}
.shop-btn .shop-icon img {
  width: 100%;
  height: 100%;
  display: block;
}
.shop-btn .text {
  font-size: 20px;
  color: #3e3e3e;
  padding-top: 10px;
}
.f-box .button {
  height: 64px;
  line-height: 64px;
  width: 262px;
  color: #fff;
  margin: 0;
  font-size: 29px;
  display: block;
  text-align: center;
  border-radius: 8px;
  margin-top: 32px;
}
.f-box .button {
  width: 262px;
  background-color: #ff3e29;
}
.f-box .button-1 {
  background-color: #ffaf46;
  margin-left: 30px;
  margin-right: 30px;
}
/deep/ .van-button {
  background: #fd6501;
  border: 1px solid #fd6501;
  width: 90%;
  margin: 0 auto;
  height: 76px;
  line-height: 76px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.projectPage {
  width: 100%;
  .topDiv {
    display: flex;
    overflow: auto;
    .div {
      width: 25%;
      height: 164px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .projectTypeImg {
        display: block;
        width: 72px;
        height: 72px;
        margin-top: 20px;
      }
      .projectTypeName {
        font-size: 28px;
        font-weight: 400;
        color: #3e3e3e;
        margin-top: 8px;
      }
      .active {
        font-weight: bold;
        color: #357dfa;
      }
    }
  }
  .bottomDiv {
    padding: 0 32px;
    .li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 32px;
      .projectImg {
        width: 240px;
        height: 240px;
        border-radius: 12px;
      }
      .project {
        width: 432px;
        .projectTop {
          position: relative;
          height: 76px;
          .name {
            width:100%;
            line-height: 40px;
            font-size: 28px;
            font-weight: bold;
            color: #3e3e3e;
            position: absolute;
            overflow: hidden; //溢出隐藏
            white-space: nowrap; //禁止换行
            text-overflow: ellipsis; //...
          }
          .price {
            line-height: 40px;
            font-size: 28px;
            font-weight: bold;
            color: #ff3e29;
            position: absolute;
            // left: 150px;
            top: 32px;
          }
        }

        .detailText {
          height: 140px;
          line-height: 40px;
          font-size: 24px;
          font-weight: 400;
          color: #b1b1b2;
          overflow: hidden; //溢出隐藏
          white-space: wrap; //禁止换行
          text-overflow: ellipsis; //...
        }
        .viewText {
          text-align: right;
          font-size: 24px;
          font-weight: 400;
          color: #3e3e3e;
        }
      }
    }
  }
}
.sticky {
  position: sticky;
  background: #fff;
  margin-bottom: 10px;
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
  top: 0;
  // font-size: 20px;
  // padding: 10px;
  z-index: 1;
}
.noAct {
  width: 342px;
  height: 271px;
}
.actText {
  font-size: 32px;
  font-weight: 400;
  color: #3e3e3e;
  text-align: center;
  padding-bottom: 60px;
}
.serviceEffect {
  min-height: 152px;
  font-size: 24px;
  font-weight: 400;
  color: #b1b1b2;
  line-height: 40px;
}
</style>
